module.exports = __webpack_public_path__ + "img/DE05874.2c618176.png";